import { Link } from 'react-router-dom';
import { EventModel } from '../models/EventModel';
import { DateUtil } from '../utils/DateUtil';
import { capitalize } from '../utils/GlobalUtil';
import { formatPrice } from '../utils/PriceUtil';
import { getVenueLabel } from '../utils/venueUtils';
import { getEventCategoryLabel } from '../utils/eventDisplayUtils';
import { useSharedState } from '../hooks/useSharedState';
import FavoriteButton from './FavoritesButton';
import ImageWithPlaceholder from './ImageWithPlaceholder';
import recurringIcon from '../assets/recurring.svg';
import styles from './EventListRow.module.css';

interface EventListRowProps {
    event: EventModel;
    onClick?: () => void;
}

export default function EventListRow({ event, onClick }: EventListRowProps) {
    const [selectedCategories] = useSharedState('categories', '');
    const path = `/details/${event.id}`;
    const price = formatPrice(event.price);
    const isRecurring = (event.recurringRules?.length ?? 0) > 0;
    const recurrenceText = DateUtil.recurringRulesToTexts(
        event.recurringRules ?? [],
        !event.timeUnkown
    )[0];
    const dateText = recurrenceText || (event.dates[0]?.date
        ? `${capitalize(DateUtil.getDayNameInFrench(event.dates[0].date))} ${DateUtil.convertToAmericaToronto(event.dates[0].date, event.timeUnkown)}`
        : '');
    const categoryLabel = getEventCategoryLabel(event.categories, selectedCategories);
    const venue = getVenueLabel(event.venue, event.locationName || '');

    return <article className={styles.row}>
        <Link to={path} onClick={onClick} className={styles.rowLink} aria-label={`Voir les détails de ${event.title}`} />
        <FavoriteButton eventId={event.id} />
        <div className={styles.imageLink}>
            {isRecurring && <span className={styles.compactRecurringBadge} aria-label="Événement récurrent">
                <img aria-hidden="true" src={recurringIcon} alt="" />
                <span aria-hidden="true">Récurrent</span>
            </span>}
            <ImageWithPlaceholder className={styles.image} src={event.imageUrl} alt={event.title} />
        </div>
        <div className={styles.content}>
            {categoryLabel && <div className={styles.compactCategory} title={event.categories.map((category) => category.name).join(', ')}>{categoryLabel}</div>}
            <div className={styles.title}>{event.title}</div>
            <div className={styles.subtitle}>
                <span>{venue}</span>
                {price && <><span aria-hidden="true"> · </span><strong>{price}</strong></>}
            </div>
        </div>
        <div className={styles.date}>{dateText}</div>
    </article>;
}
